import { AppConfig } from '@ltvco/refresh-lib/ctx';
import { useQuery } from '@ltvco/refresh-lib/vendors';
import { useContext } from 'react';

import { fdaRecalls } from '../api';

import { FDA_RECALLS_QUERY_KEY_PREFIX } from './constants';

import type {
  FdaEnforcementParams,
  FdaEnforcementResponse,
} from '../interfaces';

export const useFdaEnforcementRecalls = (
  params: FdaEnforcementParams | null | undefined,
  options?: { enabled?: boolean }
) => {
  const { logError } = useContext(AppConfig);
  const enabled = (options?.enabled !== false && !!params?.domain) ?? false;

  return useQuery<FdaEnforcementResponse>(
    [FDA_RECALLS_QUERY_KEY_PREFIX, params?.domain, params?.searchParams],
    () => fdaRecalls.fetchEnforcement(params!),
    {
      enabled,
      refetchOnWindowFocus: false,
      onError: (error: unknown) => {
        logError(`${FDA_RECALLS_QUERY_KEY_PREFIX} failed`, error as Error);
      },
    }
  );
};
